import type { CelestialBodyDefinition } from "../types/celestialBody";

export function validateCelestialBody(
  body: CelestialBodyDefinition,
): string[] {
  const errors: string[] = [];

  if (!body.id) errors.push("id obrigatório");
  if (!body.name) errors.push("name obrigatório");
  if (body.physical.meanRadiusKm <= 0) {
    errors.push(`${body.id}: raio médio deve ser > 0`);
  }

  if (body.type !== "star" && !body.orbit) {
    errors.push(`${body.id}: órbita obrigatória para corpos não-estelares`);
  }

  if (body.orbit) {
    if (body.orbit.semiMajorAxisKm <= 0) {
      errors.push(`${body.id}: semiMajorAxisKm inválido`);
    }
    if (body.orbit.eccentricity < 0 || body.orbit.eccentricity >= 1) {
      errors.push(`${body.id}: excentricidade fora de [0, 1)`);
    }
    if (body.orbit.orbitalPeriodDays <= 0) {
      errors.push(`${body.id}: período orbital inválido`);
    }
  }

  return errors;
}

export function validateCatalog(bodies: CelestialBodyDefinition[]): string[] {
  const errors: string[] = [];
  const ids = new Set<string>();

  for (const body of bodies) {
    if (ids.has(body.id)) errors.push(`id duplicado: ${body.id}`);
    ids.add(body.id);
    errors.push(...validateCelestialBody(body));
  }

  for (const body of bodies) {
    if (body.parentId && !ids.has(body.parentId)) {
      errors.push(`${body.id}: parentId inexistente (${body.parentId})`);
    }
  }

  return errors;
}
